module.exports = __webpack_public_path__ + "img/download.bea216cd.svg";